import type { FeatureFlagKey } from '@sb/feathers-types';
import type { StepKind } from '@sb/routine-runner';

/**
 * Shared source of truth for MoveArmToV2 permitted child step kinds.
 * Mirrors the UI behavior but is exported from the validation library
 * so both UI and server can consume the same rule.
 */
export function getPermittedChildStepKindsShared(
  featureFlags: Partial<Record<FeatureFlagKey, boolean>> = {},
): readonly StepKind[] {
  const { allowSubstepsMoveStepV2, arcStepInMove } = featureFlags;

  const permittedSteps: StepKind[] = ['Waypoint'];

  if (allowSubstepsMoveStepV2) {
    permittedSteps.push('SetIO', 'SetEnvironmentVariable');
  }

  if (arcStepInMove) {
    permittedSteps.push('Arc');
  }

  return permittedSteps;
}
